import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import ReactGA from 'react-ga4';

import FormPopup from '@components/FormPopup';
import { GlobalContext } from '@components/Context/GlobalContext';

import { getBullyingDefence } from '@api/bullyingDefence';

import useSpinner from '@hooks/useSpinner';

import '../styles/globals.scss';

type TApp = {
  Component: any;
  pageProps: any;
};

function App({ Component, pageProps: { session, ...pageProps } }: TApp) {
  const isProduction = process.env.NEXT_PUBLIC_ENV === 'prod';
  const [bullyingData, setBullyingData] = useState(null);

  const { events } = useRouter();
  const { setIsVisible } = useSpinner()[0];
  const loadingTimer = useRef(null);

  useEffect(() => {
    const getBiases = async () => {
      const biases = await getBullyingDefence();
      setBullyingData(biases);
    };
    setBullyingData(getBiases);
  }, []);
  
  useEffect(() => {
    events.on('routeChangeStart', () => {
      clearTimeout(loadingTimer.current);
      loadingTimer.current = setTimeout(() => {
        setIsVisible(true);
      }, 500);
    });

    events.on('routeChangeComplete', url => {
      ReactGA.set({ page: url });
      ReactGA.send(url);

      clearTimeout(loadingTimer.current);
      setIsVisible(false);
    });

    events.on('routeChangeError', () => {
      clearTimeout(loadingTimer.current);
      setIsVisible(false);
    });
  }, []);

  useEffect(() => {
    if (isProduction) {
      ReactGA.initialize(process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID);
      setTimeout(() => {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.send(window.location.pathname);
      }, 0);
    }
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        bullyingData,
        setBullyingData,
      }}
    >
      <Component {...pageProps} />
      <FormPopup />
    </GlobalContext.Provider>
  );
}

export default App;
